import { render, staticRenderFns } from "./CorrelatedFields.vue?vue&type=template&id=6a181f5e&scoped=true&"
import script from "./CorrelatedFields.vue?vue&type=script&lang=ts&"
export * from "./CorrelatedFields.vue?vue&type=script&lang=ts&"
import style0 from "./CorrelatedFields.vue?vue&type=style&index=0&id=6a181f5e&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a181f5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlider } from 'vuetify/lib/components/VSlider';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSlider,VTextField})
